/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it work on mobile and in dark mode?`)
};

const es_bar_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Funciona en móvil y en modo oscuro?`)
};

const de_bar_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioniert es auf Mobilgeräten und im Dunkelmodus?`)
};

const nl_bar_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werkt het op mobiel en in donkere modus?`)
};

const fr_bar_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionne-t-il sur mobile et en mode sombre ?`)
};

const it_bar_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funziona su mobile e in modalità scura?`)
};

const pt_br2_bar_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciona em dispositivos móveis e no modo escuro?`)
};

const pt_bar_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciona em dispositivos móveis e em modo escuro?`)
};

const ja_bar_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モバイルやダークモードでも動作しますか？`)
};

const zh_bar_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否支持移动端和深色模式？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_faq_q3", locale)
	if (locale === "en") return en_bar_faq_q3(inputs)
	if (locale === "es") return es_bar_faq_q3(inputs)
	if (locale === "de") return de_bar_faq_q3(inputs)
	if (locale === "nl") return nl_bar_faq_q3(inputs)
	if (locale === "fr") return fr_bar_faq_q3(inputs)
	if (locale === "it") return it_bar_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_bar_faq_q3(inputs)
	if (locale === "pt") return pt_bar_faq_q3(inputs)
	if (locale === "ja") return ja_bar_faq_q3(inputs)
	return zh_bar_faq_q3(inputs)
};